import { NgModule } from '@angular/core';
import { PlaceOrderCrawlComponent } from './crawl.component';
import { PlaceOrderModule } from '@schoolbelle/shared/components';

@NgModule({
  declarations: [PlaceOrderCrawlComponent],
  imports: [
    PlaceOrderModule,
  ],
  exports : [PlaceOrderCrawlComponent],

})
export class PlaceOrderCrawlModule { }
